import React from 'react'
import Seo from '../components/seo'
import ProjectTemplate from './projectTemplate'
import usePageInit from '../hooks/usePageInit'


const Project = ({ pageContext }) => {
    usePageInit();
    return (
        <>
            <Seo seo={pageContext.data?.seo}></Seo>
            <ProjectTemplate context={pageContext.data} lang={pageContext.lang} nextSlug={pageContext.nextSlug} prevSlug={pageContext.prevSlug} />
        </>
    )
}

export default Project;
